import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { mergeStyles, ActionButton } from '@fluentui/react';
export var StepperNodeStatus = /*#__PURE__*/ function(StepperNodeStatus) {
    StepperNodeStatus["Active"] = "Active";
    StepperNodeStatus["Completed"] = "Completed";
    StepperNodeStatus["NotCompleted"] = "NotCompleted";
    StepperNodeStatus["Failed"] = "Failed";
    StepperNodeStatus["Hidden"] = "Hidden";
    return StepperNodeStatus;
}({});
export const StepperColors = {
    Error: '#A80000',
    Completed: '#00AD56',
    Active: '#0078D4',
    NotCompleted: '#979593',
    Text: '#323130'
};
export var StepId = /*#__PURE__*/ function(StepId) {
    StepId[StepId["SelectBillingCountry"] = 0] = "SelectBillingCountry";
    StepId[StepId["SelectPlan"] = 1] = "SelectPlan";
    StepId[StepId["SelectTerm"] = 2] = "SelectTerm";
    StepId[StepId["Payment"] = 3] = "Payment";
    StepId[StepId["ConfigureNow"] = 4] = "ConfigureNow";
    StepId[StepId["TeamsVirtualStep"] = 5] = "TeamsVirtualStep";
    return StepId;
}({});
export const separatorStyle = {
    minHeight: '36px',
    maxWidth: '1px',
    borderLeft: '#106ebe 2px solid',
    marginLeft: '16px'
};
export const stepperStyle = mergeStyles({
    display: 'flex',
    flexDirection: 'column',
    minWidth: '190px'
});
export const rowStyle = mergeStyles({
    display: 'flex',
    flexDirection: 'row'
});
export const GetIconByStatusAndColor = (nodeName, color)=>{
    const stepperNodeStatuses = {
        ["Active"]: {
            className: 'ms-fontWeight-semibold',
            iconName: 'CircleShapeSolid',
            ariaLabel: 'Active'
        },
        ["Completed"]: {
            className: 'ms-fontWeight-regular',
            iconName: 'CompletedSolid',
            ariaLabel: 'Completed'
        },
        ["NotCompleted"]: {
            className: 'ms-fontWeight-regular',
            iconName: 'CircleRing',
            ariaLabel: 'Not Completed'
        },
        ["Failed"]: {
            className: 'ms-fontWeight-regular',
            iconName: 'StatusErrorFull',
            ariaLabel: 'Something went wrong'
        }
    };
    const currentStepperNodeStatus = stepperNodeStatuses[`${nodeName}`];
    return /*#__PURE__*/ _jsx(ActionButton, {
        className: `stepperClass ${currentStepperNodeStatus.className}`,
        iconProps: {
            iconName: currentStepperNodeStatus.iconName,
            style: {
                color
            }
        },
        ariaLabel: currentStepperNodeStatus.ariaLabel,
        disabled: true
    });
};
const IconStatusMapping = (stepStatus, color)=>{
    return GetIconByStatusAndColor(stepStatus, color);
};
const Stepper = (props)=>{
    const AllSteps = props.steps.map((step, i)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: stepperStyle,
            children: /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: rowStyle,
                        children: /*#__PURE__*/ React.cloneElement(IconStatusMapping(step.stepStatus, step.color), {
                            text: step.displayName,
                            ariaLabel: step.ariaLabel
                        })
                    }),
                    i < props.steps.length - 1 && /*#__PURE__*/ _jsx("div", {
                        className: mergeStyles(separatorStyle, {
                            borderColor: step.color === StepperColors.Error ? StepperColors.Active : step.color
                        })
                    })
                ]
            })
        }, step.id);
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: AllSteps
    });
};
export default Stepper;
